import React from 'react'
import '../../Styles/Routes/VideoArriendo/VideoArriendo.css'
import NavegadorArriendos from '../../Components/Arriendos/NavegadorArriendos'
import { Row, Col, Affix, Skeleton } from 'antd'

export default function VideoArriendo() {
    return (
        <>
            <div className="Container-Main Container-Status" style={{ paddingBottom: 0 }}>
                <Row>
                    <Col span={24}>
                        <Affix offsetTop={36}>
                            <div className="Container-Button-Status">
                                <NavegadorArriendos />
                            </div>
                        </Affix>
                    </Col>
                    <Col span={24}>
                        <div className='container-video'>
                            <h1 className='titulo-video'>1. Módulo de Arriendos desde cero</h1>
                            <iframe
                                style={{ height: '80vh' }}
                                width="80%"
                                src="https://www.youtube.com/embed/HO5zcZC97us?si=uhgks_Oa75viH_le"
                                title="YouTube video player"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerPolicy="strict-origin-when-cross-origin"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </Col>
                </Row>
            </div>

        </>
    )
}
